module.exports = __webpack_public_path__ + "img/Feature.60f25cab.png";